// src/config.js
const config = {
    API_KEY: 'sk-proj-EUXARpXXXvSQmGLtSJK4T3BlbkFJM7oGUb767sTOV45UbOXj'
  };
  
  export default config;
  